var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.3,256l139.6-139.5c17.5-17.5,17.5-45.8,0-63.3c-17.5-17.5-45.8-17.5-63.3,0L256,192.7L116.5,53.1 c-17.5-17.5-45.8-17.5-63.3,0s-17.5,45.8,0,63.3L192.7,256L53.1,395.5c-17.5,17.5-17.5,45.8,0,63.3c17.6,17.5,45.9,17.5,63.3,0 L256,319.3l139.6,139.5c17.5,17.5,45.8,17.5,63.3,0c17.4-17.5,17.4-45.8-0.2-63.4L319.3,256z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Close.ceb8bb4b67b34b27d80fb23fb6bac2b6.svg";